import React from "react";
import config from "Config";
import { state } from "../state";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import withProps from "recompose/withProps";
import withState from "recompose/withState";
import InterpreterSymbol from "Assets/img/Interpreter-Symbol.png";
import { HelpVideoLinks } from "Components/Common";

const addShowModalState = withProps({
  show: () =>
    !eval(window.localStorage.getItem("dontShow")) &&
    state.get(["ui", "modal_open"]),
  toggleShow: () =>
    state.set(["ui", "modal_open"], !state.get(["ui", "modal_open"]))
});

const bodyParaOne = `The ${config.client_department_name} (${config.client_department_acronym}) developed this website so that Members of Parliament, State Government agencies, local governments, non-government organisations (NGOs), community groups, students and other members of the public, would be able to access a range of information on different population groups sourced from the national Census of Population and Housing.`;

const bodyParaTwo = `Information is available for demographic, cultural and socioeconomic characteristics of people living across the State. It profiles these characteristics for all ${config.admin_state_name} electoral divisions and local government areas.`;

const FooterPara = () => 
  <React.Fragment>
    For {config.client_department_acronym} enquiries please call {config.client_contact_tel_alpha} ({config.client_contact_tel}) or go to <a href={config.client_contact_url} target="_blank" rel="noopener" >{config.client_contact_url}</a>
  </React.Fragment>;

const ModalTemplate = ({ show, toggleShow }) => (
  <Modal
    isOpen={show()}
    toggle={toggleShow}
    size="lg"
    className="modal-dialog modal-lg"
  >
    <div className="modal-header d-flex white">
      <div className="">
        <h3>Welcome to Search Diversity {config.admin_state_name}</h3>
      </div>
      <div className="ml-auto">
        <button
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={toggleShow}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <ModalBody className="white text-justify">
      {bodyParaOne}
      <br />
      <br />
      {bodyParaTwo}
      <br />
      <br />
      <h4>Assistance</h4>
      If you are deaf or have a hearing or speech impairment, you can call the
      National Relay Service on:
      <br />
      <ul>
        <li>{config.client_tty_number} (TTY/Voice) or</li>
        <li>{config.client_deaf_number} (Speak and Listen).</li>
      </ul>
      <img
        style={{ width: "1rem", marginBottom: 3 }}
        src={InterpreterSymbol}
        alt="Translating and Interpreting Service"
      />{" "}
      If you need an interpreter, call the Translating and Interpreting Service
      (TIS National) on {config.client_translation_tel}. If you need any other
      assistance please contact us using the details above.
      <hr />
      <HelpVideoLinks />
    </ModalBody>
    <ModalFooter className="d-flex">
      <div className="col-9" style={{ margin: "0px" }}>
        <small className="text-justify" style={{ color: "grey" }}>
          <FooterPara/>
          <br />
          For technical enquiries about the website please email{" "}
          {config.support_email}
        </small>
      </div>

      <div className="col-3" style={{ margin: "0px" }}>
        <Button
          className="btn-block btn-sm"
          color="primary"
          onClick={toggleShow}
        >
          Start Exploring <i className="fa pl-2 fa-arrow-right" />
        </Button>

        <hr />

        <DontShowAgainButton />
      </div>
    </ModalFooter>
  </Modal>
);

const DontShowAgainButtonTemplate = ({ checked, toggleChecked }) => (
  <Button
    className="btn-block btn-light btn btn-sm"
    onClick={() => {
      window.localStorage.setItem("dontShow", String(!!!checked));
      toggleChecked(!checked);
    }}
  >
    Don't show again{" "}
    <i className={`fa pl-2 fa-${checked ? "check-square-o" : "square-o"}`} />
  </Button>
);

const addCheckedState = withState("checked", "toggleChecked", false);
const DontShowAgainButton = addCheckedState(DontShowAgainButtonTemplate);

export default addShowModalState(ModalTemplate);



// WEBPACK FOOTER //
// ./components/MainModal.js